import React, { useState, useEffect } from 'react'
import { getEventDataByPageNo, getaggregatorLinkDataByPageNo, getAggregatorLinkReportAPI } from '../../actioncreator'

import Loader from '../../../../../presentationals/Loader/Loader.component'
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import VisibilityIcon from '@mui/icons-material/Visibility';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import { CHECK_COMPANY_TENANT, CASHBRIDGE_LIKE, CREDFIN_LIKE } from '../../../../../../layouts/MainTenantconfig';
import CopyAllIcon from '@mui/icons-material/CopyAll';
import { Handshake, Spotlight } from 'lucide-react';
import Pagination from '@mui/material/Pagination';

// const url = "https://play.google.com/store/apps/details?id=com.cashbridge.app"
const url = CHECK_COMPANY_TENANT(CASHBRIDGE_LIKE) ? "https://play.google.com/store/apps/details?id=com.cashbridge.app&referrer=agentid%3D" : "https://play.google.com/store/apps/details?id=com.credfin.money&referrer=agentid%3D"
// const url = "https://loan.cashbridge.in?id="

const customBtnStyle = {
    borderRadius: '8px',
    padding: '5px 10px',
    display: 'flex',
    alignItems: 'center',
    gap: '7px'
}

const size = 10;

export default function AggregatorLsiting({ detailShow, setDetailsShow, admin, EyeHandler, EditHandler }) {
    const [currentTab, setCurrentTab] = useState("partner")
    const [active, setIsactive] = useState("active")
    const [loader, setLoader] = useState(false)
    const [tableData, setTableData] = useState({})
    const [expandedAggregator, setExpandedAggregator] = useState(null);

    const [currentOpenAggregatorId, setcurrentOpenAggregatorId] = useState("")

    const [currentPage, setCurrentPage] = useState(1)
    const [totalCount, setTotalCount] = useState(0)
    const [userList, setUserlist] = useState([])



    useEffect(() => {
        listApi()
    }, [])

    const listApi = () => {
        setLoader(true)
        getEventDataByPageNo(callback => {
            setLoader(false)
            handleFilteration(callback?.data, active)
        })
    }

    const handleFilteration = (data, type) => {
        setTableData(data?.[type])
    }

    const handlechange = (e) => {
        setIsactive(e.target.value)
    }

    const handleApplyFilter = () => {
        listApi()
    }

    const handleShowPartners = (aggregator) => {
        setExpandedAggregator((prev) =>
            prev === aggregator ? null : aggregator
        );
        handleTableView("partner", "")
    };

    const handleEye = (partnerId, listData) => {
        EyeHandler(partnerId, listData)
        setDetailsShow('view')

    };

    const editHandler = (item) => {
        EditHandler(item);
        setDetailsShow('edit')
    }

    const handleCopy = (id) => {
        const urlNew = url + id;
        navigator.clipboard.writeText(urlNew);
        alert("Link copied Successfully!")
    }

    const handleTableView = (type, value) => {
        console.log("val", value)
        setCurrentTab(type)
        setCurrentPage(1)
        setcurrentOpenAggregatorId(value)
        if (type == "leads") {
            setLoader(true)
            getaggregatorLinkDataByPageNo(value, 1, size, callback => {
                setLoader(false)
                setUserlist(callback?.data?.aggregatorLinkData ?? [])
                setTotalCount(callback?.data?.totalCount ?? 0)
            })
        }
    }

    const handlePageChange = (event, value) => {
        setCurrentPage(value);
        setLoader(true)
        getaggregatorLinkDataByPageNo(currentOpenAggregatorId, value, size, callback => {
            setUserlist(callback?.data?.aggregatorLinkData ?? {})
            setLoader(false)
            setTotalCount(callback?.data?.totalCount ?? 0)
        })
    };

    const handleDownload = () => {
        setLoader(true)
        getAggregatorLinkReportAPI(callback => {
            setLoader(false)
        })
    }


    return (
        <>
            {
                detailShow == "list" ?
                    <>
                        {loader ? <Loader /> : ""}
                        <div className='HeadingFilter-main-filters'>
                            <div className="row">
                                <div className="col-sm-9 col-xs-12" style={{ display: 'flex', gap: '10px', marginTop: '5px' }}>

                                    <select className='customSelectBox' value={active} onChange={(e) => handlechange(e)}>
                                        <option value="">Select Is Active</option>
                                        <option value="active">Active</option>
                                        <option value="inActive">InActive</option>

                                    </select>

                                </div>
                                <div className="col-sm-3 col-xs-12" style={{ marginTop: '5px' }}>
                                    <div style={{ display: 'flex', gap: '8px', justifyContent: "end" }}>
                                        {
                                            CHECK_COMPANY_TENANT(CASHBRIDGE_LIKE) || CHECK_COMPANY_TENANT(CREDFIN_LIKE) ?
                                                <div className='custom-btn' onClick={() => handleDownload()}>
                                                    <i class="fa fa-download" aria-hidden="true"></i>
                                                </div>
                                                : ""}
                                        <div className='custom-btn' onClick={() => handleApplyFilter()}>
                                            <i class="fa fa-filter" aria-hidden="true"></i>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* <div className="container"> */}
                        <div className="row">
                            <div className="col-xs-12">
                                <div className="customDash-table" style={{ marginTop: '20px' }}>
                                    <div>
                                        <h5>Aggregator Table</h5>
                                    </div>
                                    <div className='main-customized-table' style={{ overflowY: 'auto', scrollbarWidth: 'thin' }}>
                                        <table className='table'>
                                            <thead>
                                                <tr>
                                                    <th colSpan={1} style={{ textAlign: 'left', width: '250px' }}>Event Name</th>
                                                    {
                                                        CHECK_COMPANY_TENANT(CREDFIN_LIKE) ?
                                                            <th colSpan={1} style={{ textAlign: 'left', width: '250px' }}>Link</th>
                                                            : ""}
                                                    <th colSpan={6}></th>

                                                </tr>
                                            </thead>
                                            <tbody>

                                                {
                                                    tableData &&
                                                    Object.keys(tableData).length > 0 &&
                                                    Object.entries(tableData).map(([val, data], id) => {
                                                        return (
                                                            <>
                                                                <tr key={id}>
                                                                    <td colSpan={1} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderRight: '1px solid #eee', borderBottom: '1px solid #eee', background: '#fff' }}>
                                                                        {val}

                                                                        <div
                                                                            onClick={() => handleShowPartners(val)}
                                                                            style={{
                                                                                cursor: 'pointer',
                                                                                transform:
                                                                                    expandedAggregator === val
                                                                                        ? 'rotate(90deg)'
                                                                                        : 'rotate(0deg)',
                                                                                transition: 'transform 0.2s ease',
                                                                            }}
                                                                        >
                                                                            <ArrowRightIcon width={20} height={20} />
                                                                        </div>
                                                                    </td>
                                                                    {
                                                                        CHECK_COMPANY_TENANT(CREDFIN_LIKE) ?

                                                                            <td style={{ background: '#fff', borderBottom: '1px solid #eee' }}>
                                                                                <a href={`${url + data?.[0]?.aggregatorId}`} target='_blank'>
                                                                                    {url + data?.[0]?.aggregatorId}
                                                                                </a>
                                                                                {/* <a href={url} target='_blank'>
                                                                                                                        {url}
                                                                                                                    </a> */}
                                                                                &nbsp;&nbsp;
                                                                                <CopyAllIcon style={{ cursor: 'pointer' }} onClick={() => handleCopy(data?.[0]?.aggregatorId)} />
                                                                            </td>
                                                                            : ""}
                                                                    <td colSpan={6}></td>

                                                                </tr>
                                                                {
                                                                    expandedAggregator === val && (
                                                                        <tr>
                                                                            <td colSpan={16} style={{ background: '#fafafa', padding: '12px', borderRadius: '8px' }}>
                                                                                <div style={{ display: 'flex', justifyContent: 'end', marginBottom: '10px' }}>
                                                                                    {currentTab == "partner" ?
                                                                                        <button className='btn btn-primary' style={customBtnStyle} onClick={() => handleTableView("leads", data?.[0]?.aggregatorId)}><Spotlight style={{ width: 'auto', height: '16px' }} /> Leads</button>
                                                                                        :
                                                                                        <button className='btn btn-primary' style={customBtnStyle} onClick={() => handleTableView("partner", "")}><Handshake style={{ width: 'auto', height: '16px' }} /> Partner</button>}
                                                                                </div>
                                                                                <table className="table table-bordered" style={{ borderRadius: '8px' }}>
                                                                                    <thead>
                                                                                        {
                                                                                            currentTab == "partner" ?

                                                                                                <tr>
                                                                                                    <th className='customBackgroundcolor' style={{ borderTopLeftRadius: '8px' }}>View Details</th>
                                                                                                    <th className='customBackgroundcolor'>Aggregator Name</th>
                                                                                                    <th className='customBackgroundcolor'>Partner Name</th>
                                                                                                    <th className='customBackgroundcolor'>Aggregator Type</th>
                                                                                                    <th className='customBackgroundcolor'>Campaign Name</th>
                                                                                                    <th className='customBackgroundcolor'>Creator Mode</th>
                                                                                                    {
                                                                                                        CHECK_COMPANY_TENANT(CASHBRIDGE_LIKE) ?
                                                                                                            <th className='customBackgroundcolor'>Link</th>
                                                                                                            : ""}

                                                                                                    <th className='customBackgroundcolor'>Status</th>
                                                                                                    <th className='customBackgroundcolor' style={{ borderTopRightRadius: '8px' }}>Edit</th>
                                                                                                </tr>
                                                                                                : ""}
                                                                                        {
                                                                                            currentTab == "leads" ?

                                                                                                <tr>
                                                                                                    <th className='customBackgroundcolor' style={{ borderTopLeftRadius: '8px' }}>Name</th>
                                                                                                    <th className='customBackgroundcolor'>Email Id</th>
                                                                                                    <th className='customBackgroundcolor'>Mobile Number</th>
                                                                                                    <th className='customBackgroundcolor'>State</th>
                                                                                                    <th className='customBackgroundcolor'>Company Name</th>
                                                                                                    <th className='customBackgroundcolor'>Is Mobile Verified</th>
                                                                                                    <th className='customBackgroundcolor'>Form Status</th>
                                                                                                    <th className='customBackgroundcolor' style={{ borderTopRightRadius: '8px' }}>Login Date</th>
                                                                                                </tr>
                                                                                                : ""}
                                                                                    </thead>
                                                                                    {
                                                                                        currentTab == "partner" ?
                                                                                            <tbody>
                                                                                                {data?.map((partner, idx) => (
                                                                                                    <tr key={idx}>
                                                                                                        <td style={{ background: '#fff', borderBottom: '1px solid #eee', borderBottomLeftRadius: idx + 1 == data?.length ? '8px' : "" }}>
                                                                                                            <VisibilityIcon style={{ cursor: 'pointer', color: '#267dff' }} onClick={() => handleEye(partner?.partnerId, partner)} />
                                                                                                        </td>
                                                                                                        <td style={{ background: '#fff', borderBottom: '1px solid #eee' }}>{partner?.companyName}</td>
                                                                                                        <td style={{ background: '#fff', borderBottom: '1px solid #eee' }}>{partner?.partnerName}</td>
                                                                                                        <td style={{ background: '#fff', borderBottom: '1px solid #eee' }}>{partner?.type}</td>
                                                                                                        <td style={{ background: '#fff', borderBottom: '1px solid #eee' }}>{partner?.campaignName}</td>
                                                                                                        <td style={{ background: '#fff', borderBottom: '1px solid #eee' }}>{partner?.creatorMode}</td>
                                                                                                        {
                                                                                                            CHECK_COMPANY_TENANT(CASHBRIDGE_LIKE) ?
                                                                                                                <td style={{ background: '#fff', borderBottom: '1px solid #eee' }}>
                                                                                                                    <a href={`${url + partner?.aggregatorId}`} target='_blank'>
                                                                                                                        {url + partner?.aggregatorId}
                                                                                                                    </a>
                                                                                                                    {/* <a href={url} target='_blank'>
                                                                                                                        {url}
                                                                                                                    </a> */}
                                                                                                                    &nbsp;&nbsp;
                                                                                                                    <CopyAllIcon style={{ cursor: 'pointer' }} onClick={() => handleCopy(partner?.aggregatorId)} />
                                                                                                                </td>
                                                                                                                : ""}

                                                                                                        <td style={{ background: '#fff', borderBottom: '1px solid #eee' }}>
                                                                                                            <div style={{
                                                                                                                background: partner?.status == true ? "rgba(102, 172, 175, 0.36)" : "#ff67674d", color: partner?.status == true ?
                                                                                                                    "rgb(3, 88, 101)" : "red",
                                                                                                                borderRadius: '8px'
                                                                                                            }}>
                                                                                                                {partner?.status ? "Active" : "Inactive"}
                                                                                                            </div>
                                                                                                        </td>

                                                                                                        <td style={{ background: '#fff', borderBottom: '1px solid #eee', borderBottomRightRadius: idx + 1 == data?.length ? '8px' : "" }}>
                                                                                                            <BorderColorIcon style={{ cursor: 'pointer', color: '#267dff' }} onClick={() => editHandler(partner)} />
                                                                                                        </td>

                                                                                                    </tr>
                                                                                                ))}
                                                                                            </tbody>
                                                                                            : ""}
                                                                                    {
                                                                                        currentTab == "leads" ?
                                                                                            <tbody>
                                                                                                {userList && userList?.map((partner, idx) => (
                                                                                                    <tr key={idx}>
                                                                                                        <td style={{ background: '#fff', borderBottom: '1px solid #eee', borderBottomLeftRadius: idx + 1 == userList?.length ? '8px' : "" }}>
                                                                                                            {partner?.firstName ?? ""}
                                                                                                        </td>
                                                                                                        <td style={{ background: '#fff', borderBottom: '1px solid #eee' }}>{partner?.emailId ?? ""}</td>
                                                                                                        <td style={{ background: '#fff', borderBottom: '1px solid #eee' }}>{partner?.mobileNumber ?? ""}</td>
                                                                                                        <td style={{ background: '#fff', borderBottom: '1px solid #eee' }}>{partner?.state ?? ""}</td>
                                                                                                        <td style={{ background: '#fff', borderBottom: '1px solid #eee' }}>{partner?.companyName ?? ""}</td>
                                                                                                        <td style={{ background: '#fff', borderBottom: '1px solid #eee' }}>{partner?.mobileVerified ?? ""}</td>
                                                                                                        <td style={{ background: '#fff', borderBottom: '1px solid #eee' }}>{partner?.formStatus ?? ""}</td>


                                                                                                        <td style={{ background: '#fff', borderBottom: '1px solid #eee', borderBottomRightRadius: idx + 1 == userList?.length ? '8px' : "" }}>
                                                                                                            {partner?.loginDate ?? ""}
                                                                                                        </td>

                                                                                                    </tr>
                                                                                                ))}
                                                                                            </tbody>
                                                                                            : ""}
                                                                                </table>
                                                                                {
                                                                                    currentTab == "leads" ?
                                                                                        <div style={{ float: 'right', marginTop: '15px' }}>
                                                                                            <Pagination
                                                                                                count={Math.ceil(totalCount / size)}
                                                                                                page={currentPage}
                                                                                                onChange={handlePageChange}
                                                                                                color="success"
                                                                                            />
                                                                                        </div>
                                                                                        : ""}
                                                                            </td>
                                                                        </tr>
                                                                    )
                                                                }
                                                            </>
                                                        )
                                                    })
                                                }

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* </div> */}
                    </>
                    : ""}



        </>
    )
}
